import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import './BulkActionsBar.css';
import '../../styles/buttons.css';

type Props = {
  selectedCount: number;
  onCancel: () => void;
  children: ReactNode;
  /**
   * バーの portal 先。
   * - 未指定 (デフォルト): document.body にビューポート fixed で表示。
   * - 指定: その要素の末端に position: absolute で貼り付ける (素材パネル等の中に表示する用途)。
   *   target は position: relative/fixed/absolute のいずれかであること。
   */
  target?: HTMLElement | null;
};

export function BulkActionsBar({ selectedCount, onCancel, children, target }: Props) {
  // 親 (ProductsLayout の .products-container 等) の backdrop-filter が
  // fixed 子孫の containing block になってしまうため、デフォルトでは Portal で
  // body 直下に出して確実にビューポート下端へ貼り付ける。
  const className = target ? 'bulk-actions-bar bulk-actions-bar--inset' : 'bulk-actions-bar';
  return createPortal(
    <div className={className}>
      <div className="bulk-actions-content">
        <span className="bulk-selected-count">{selectedCount}件選択中</span>
        {children}
        <button
          type="button"
          className="bulk-action-btn bulk-cancel-btn btn-modal-secondary"
          onClick={onCancel}
          aria-label="一括編集モードをキャンセル"
        >
          ✕
        </button>
      </div>
    </div>,
    target ?? document.body,
  );
}
